import {Injectable} from '@angular/core';
import {EventsResponseInterface} from '@app/core/models/events-response.interface';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import { LoginResponseInterface } from '@app/core/models/login-response.interface';
import { EventInterface } from '@app/core/models/event.interface';
import { CtaInterface } from '@app/core/models/cta.interface';
import { ModalSimpleInterface } from '@app/core/models/modal-simple.interface';
import { ModalSendEmailInterface } from '@app/core/models/modal-send-email.interface';
import { EventResponseInterface } from '@app/core/models/event-response.interface';
import moment from 'moment';
import {TaskInterface} from '@app/core/models/task.interface';
import {CalendarView} from 'angular-calendar';

@Injectable({
  providedIn: 'root'
})

export class CalendarService {

  public subscriptions$: Subscription = new Subscription();

  getAllEvents(unformattedEvents: EventResponseInterface[]): any[] {
    const formattedEvents: any[] = [];
    for (const task of unformattedEvents) {
      const startDate = moment(task.startPlannedDate).toDate();
      const endDate = task.endPlannedDate ? moment(task.endPlannedDate).toDate() : new Date(startDate.getTime() + 3600000);
      const customerName = task.customer ? task.customer.name : null;
      const newEventObject: EventInterface = {
        administrator: task.administrator,
        checkType: task.checkType,
        classification: task.classification,
        customer: customerName,
        description: task.taskDescription,
        division: task.division,
        end: endDate,
        factoryNumber: task.factoryNumber,
        code: task.code,
        id: task.id,
        kw: task.kw,
        maintainer: task.maintainer,
        notes: task.planningNotes,
        start: startDate,
        plantAddress: task.plantAddress,
        plantCity: task.plantCity,
        plantProvince: task.plantProvince,
        serialNumber: task.serialNumber,
        state: task.state,
        isAssigned: false,
        ctaTask: (task.id) ? {
            label: '',
            url: '/lista-interventi/dettaglio-intervento/' + task.id,
            icon: 'icon-s-arrow-right',
          } : null,
        ctaModal: {
          label: '',
          icon: 'icon-s-info',
          modalSimple: {
            ctaPositive: {
              label: 'Chiudi',
            }
          }
        },
        statusClass: ''
      };
      formattedEvents.push(newEventObject);
    }
    return formattedEvents;
  }

  checkifAssigned(events: EventInterface[], tasks: TaskInterface[]): EventInterface[] {
    events.forEach((event) => {
      event.isAssigned = false;
      tasks.forEach((task) =>  {
        if (task.id === event.id) {
          event.isAssigned = true;
        }
      });
    });
    return events;
  }

  getDateRangeForView(view: CalendarView, viewDate: Date): { fromDate: string; toDate: string } {
    const momentDate = moment(viewDate);

    if (view === CalendarView.Week) {
      const startOfWeek = momentDate.clone().startOf('isoWeek').subtract(1, 'day');
      const endOfWeek = momentDate.clone().endOf('isoWeek');

      return {
        fromDate: startOfWeek.format('DD/MM/YYYY'),
        toDate: endOfWeek.format('DD/MM/YYYY')
      };
    } else if (view === CalendarView.Day) {
      const dayStart = momentDate.clone().subtract(1, 'day');
      return {
        fromDate: dayStart.format('DD/MM/YYYY'),
        toDate: momentDate.format('DD/MM/YYYY')
      };
    }

    return null;
  }
}
